import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable({
  providedIn: 'root',
})
export class MatPaginatorIntlEsp extends MatPaginatorIntl {
  page = 25;
  pageSizeOptions: number[] = [10, 25, 50, 100, 150];
  ofLabel = 'de';
  override firstPageLabel = 'Primera pág.';
  override itemsPerPageLabel = 'Items por pág.';
  override lastPageLabel = 'Última pág.';
  override nextPageLabel = 'Pág. siguiente';
  override previousPageLabel = 'Pág. anterior';

  public get defaultPage(): number {
    return this.page;
  }

  public get SizeOptions(): number[] {
    return this.pageSizeOptions;
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.ofLabel} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${length}`;
  };
}
